import React from "react";
import { useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import { useQuery } from "@apollo/client";
import { GET_USER_STATE } from "api/graphql/queries";

function myProfile(location, userState) {
  if (userState) {
    if (userState.lolSettings.summoners) {
      const { summonerName, regionId } = userState.lolSettings.summoners[0];
      if (summonerName && regionId) {
        const profileURL = `/lol/profile/${regionId}/${summonerName.toLowerCase()}`;
        if (location.pathname.match(profileURL)) {
          return true;
        }
      }
    }
  }

  return false;
}

function discoverBoost(location) {
  if (location.pathname.match(/\/discover-boost/g)) {
    return true;
  }
  return false;
}

function supportUs(location) {
  if (location.pathname.match(/\/support-us/g)) {
    return true;
  }
  return false;
}

function desktopApp(location) {
  if (location.pathname.match(/\/app/g)) {
    return true;
  }
  return false;
}

function yearInReview(location) {
  if (location.pathname.match(/\/year-in-review/g)) {
    return true;
  }

  return false;
}

function homepage(location) {
  if (location.pathname === "" || location.pathname === "/") {
    return true;
  }

  return false;
}

function worldsTracker(location) {
  if (location.pathname === "/worlds") {
    return true;
  }

  return false;
}

function tierList(location) {
  if (
    location.pathname.match(/\/lol\/tier-list/g) ||
    location.pathname.match(/\/lol\/duo-tier-list/g) ||
    location.pathname.match(/\/lol\/combat/g) ||
    location.pathname.match(/\/lol\/objectives/g)
  ) {
    return true;
  }

  return false;
}

function liveGame(location) {
  return location.pathname.includes("live-game");
}

function multisearch(location) {
  return location.pathname.match(/^(\/multisearch)/g);
}

function leaderboards(location) {
  return location.pathname.match(/^(\/leaderboards)/g);
}

function champion(location) {
  if (
    location.pathname.match(/\/lol\/champions/) ||
    location.pathname.match(/\/lol\/champions\/[A-Za-z0-9\s]+\/build/g) ||
    location.pathname.match(/\/lol\/champions\/[A-Za-z0-9\s]+\/counters/g) ||
    location.pathname.match(/\/lol\/champions\/[A-Za-z0-9\s]+\/items/g) ||
    location.pathname.match(/\/lol\/champions\/[A-Za-z0-9\s]+\/runes/g) ||
    location.pathname.match(/\/lol\/champions\/[A-Za-z0-9\s]+\/spells-abilities/g)
  ) {
    return true;
  }

  return false;
}

const championLeaderboards = (location) => {
  if (location.pathname.match(/\/lol\/champion-leaderboards?\/?\S+/)) {
    return true;
  }
};

function items(location) {
  if (location.pathname.match(/\/lol\/items?\/?\S+/)) {
    return true;
  }
  return false;
}

function summonerProfile(location) {
  if (location.pathname.match(/\/lol\/profile\//g)) {
    return true;
  }
  return false;
}

function isFavoriteChampion(location, favoriteChampions) {
  var championNameArray = location.pathname.match(/\/lol\/champions\/(.*?)\//);
  if (!favoriteChampions) return null;

  if (championNameArray) {
    var championName = championNameArray[1];
    var championFound = false;

    favoriteChampions.map(function (element) {
      if (element.normalizedChampionName === championName) {
        championFound = true;
      }
    });

    if (championFound) {
      return championName;
    }
  }
}

function isFollowedSummoner(location, followedSummoners) {
  var matchArray = location.pathname.match(/\/lol\/profile\/.*?\/(.*?)\//);
  if (!followedSummoners) return null;

  if (matchArray) {
    var summonerName = matchArray[1].toLowerCase();
    var summonerFound = false;

    followedSummoners.map(function (element) {
      if (element.summonerName.toLowerCase() === summonerName) {
        summonerFound = true;
      }
    });

    if (summonerFound) {
      return summonerName;
    }
  }
}

export function getActiveName() {
  const location = useLocation();
  const [favoriteChampions] = useGlobal("clientChampionFavorites");
  const [followedSummoners] = useGlobal("clientSummonerFavorites");
  const { loading, data, error } = useQuery(GET_USER_STATE);

  if (champion(location)) {
    const favoriteChampion = isFavoriteChampion(location, favoriteChampions);
    if (favoriteChampion) {
      return favoriteChampion;
    } else {
      return "Champions";
    }
  } else if (championLeaderboards(location)) {
    return "Champions";
  } else if (items(location)) {
    return "Items";
  } else if (yearInReview(location)) {
    return "YearInReview";
  } else if (tierList(location)) {
    return "TierList";
  } else if (leaderboards(location)) {
    return "Leaderboards";
  } else if (multisearch(location)) {
    return "MultiSearch";
  } else if (liveGame(location)) {
    return "LiveGame";
  } else if (summonerProfile(location)) {
    let followedSummoner = isFollowedSummoner(location, followedSummoners);
    return followedSummoner;
  } else if (myProfile(location, data && data.getState)) {
    return "MyProfile";
  } else if (homepage(location)) {
    return "Homepage";
  } else if (worldsTracker(location)) {
    return "WorldsTracker";
  } else if (discoverBoost(location)) {
    return "Premium";
  } else if (supportUs(location)) {
    return "SupportUs";
  } else if (desktopApp(location)) {
    return "DesktopApp";
  } else {
    let followedSummoner = isFollowedSummoner(location, followedSummoners);
    return followedSummoner;
  }
}
